// extracted by mini-css-extract-plugin
export var accentMove = "testimonial-module--accentMove--c6a90";
export var pic = "testimonial-module--pic--f645a";